export default {"src":"/_next/static/media/matterport-property.86fc0f9f.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};